import Vue from 'vue'
import VueMoveDom from '~/directives/vue-move-dom'

Vue.use(VueMoveDom)
